(function() {
  'use strict';

  var drawer;
  var overlay;
  var closeButtons;
  var itemList;
  var emptyState;
  var subtotalNode;
  var discountNode;
  var discountAmountNode;
  var discountPillsNode;
  var footerNode;
  var shippingTextNode;
  var shippingFillNode;
  var countNode;
  var errorNode;
  var liveRegion;
  var checkoutButton;
  var lastFocusedElement;
  var refreshTimer;
  var quantityTimers = {};
  var quantityLoadingButtons = {};
  var isOpen = false;
  var isFetching = false;
  var isOfferDiscountCleanup = false;
  var lastCartHadMenopauseOfferLine = null;
  var lockedScrollPosition = 0;

  var selectors = {
    shell: '[data-np-cart-drawer]',
    overlay: '[data-np-cart-drawer-overlay]',
    close: '[data-np-cart-drawer-close]',
    items: '[data-np-cart-drawer-items]',
    empty: '[data-np-cart-drawer-empty]',
    subtotal: '[data-np-cart-drawer-subtotal]',
    discount: '[data-np-cart-drawer-discount]',
    discountAmount: '[data-np-cart-drawer-discount-amount]',
    discountPills: '[data-np-cart-drawer-discount-pills]',
    footer: '[data-np-cart-drawer-footer]',
    shippingText: '[data-np-cart-drawer-shipping-text]',
    shippingFill: '[data-np-cart-drawer-shipping-fill]',
    count: '[data-np-cart-drawer-count]',
    error: '[data-np-cart-drawer-error]',
    live: '[data-np-cart-drawer-live]',
    checkout: '[data-np-cart-drawer-checkout]',
    cartCount: '[data-cart-count]',
    cartCountBubble: '[data-cart-count-bubble]',
    cartPopupWrapper: '[data-cart-popup-wrapper]'
  };

  function init() {
    drawer = document.querySelector(selectors.shell);
    if (!drawer || drawer.dataset.npCartDrawerReady === 'true') return;

    drawer.dataset.npCartDrawerReady = 'true';
    overlay = drawer.querySelector(selectors.overlay);
    closeButtons = drawer.querySelectorAll(selectors.close);
    itemList = drawer.querySelector(selectors.items);
    emptyState = drawer.querySelector(selectors.empty);
    subtotalNode = drawer.querySelector(selectors.subtotal);
    discountNode = drawer.querySelector(selectors.discount);
    discountAmountNode = drawer.querySelector(selectors.discountAmount);
    discountPillsNode = drawer.querySelector(selectors.discountPills);
    footerNode = drawer.querySelector(selectors.footer);
    shippingTextNode = drawer.querySelector(selectors.shippingText);
    shippingFillNode = drawer.querySelector(selectors.shippingFill);
    countNode = drawer.querySelector(selectors.count);
    errorNode = drawer.querySelector(selectors.error);
    liveRegion = drawer.querySelector(selectors.live);
    checkoutButton = drawer.querySelector(selectors.checkout);

    bindDrawerEvents();
    bindCartEvents();
    observeLegacyPopup();
    watchAjaxAddToCart();
    refresh(false);
  }

  function bindDrawerEvents() {
    if (overlay) overlay.addEventListener('click', close);

    Array.prototype.forEach.call(closeButtons, function(button) {
      button.addEventListener('click', close);
    });

    drawer.addEventListener('click', function(event) {
      var button = event.target.closest('[data-np-cart-drawer-qty]');
      var removeButton = event.target.closest('[data-np-cart-drawer-remove]');

      if (button) {
        handleQuantityButton(button);
        return;
      }

      if (removeButton) {
        event.preventDefault();
        changeQuantity(removeButton.getAttribute('data-line-key'), 0);
      }
    });

    drawer.addEventListener('change', function(event) {
      var input = event.target.closest('[data-np-cart-drawer-qty-input]');
      if (!input) return;

      var key = input.getAttribute('data-line-key');
      var quantity = parseInt(input.value, 10);

      if (isNaN(quantity) || quantity < 0) {
        quantity = 1;
        input.value = quantity;
      }

      queueQuantityChange(key, quantity);
    });

    document.addEventListener('keydown', function(event) {
      if (!isOpen || event.key !== 'Escape') return;
      close();
    });

    document.addEventListener('click', function(event) {
      var link = event.target.closest('a[href]');
      if (!link || drawer.contains(link) || !isCartPageLink(link)) return;

      event.preventDefault();
      open({ refresh: true });
    });
  }

  function bindCartEvents() {
    document.addEventListener('cart:refresh', handleCartEvent);
    document.addEventListener('cart:updated', handleCartEvent);
    document.addEventListener('cart:open', handleCartEvent);
    window.addEventListener('cart:refresh', handleCartEvent);
    window.addEventListener('cart:updated', handleCartEvent);
    window.addEventListener('cart:open', handleCartEvent);
  }

  function handleCartEvent(event) {
    var shouldOpen = event.type === 'cart:open' || !!(event.detail && event.detail.open);

    if (shouldOpen) {
      open({ refresh: true });
      return;
    }

    if (isOpen || event.type === 'cart:refresh' || event.type === 'cart:updated') {
      refresh(false);
    }
  }

  function open(options) {
    options = options || {};
    if (!drawer) return;

    lastFocusedElement = document.activeElement;
    if (!isOpen) lockPageScroll(options.scrollPosition);
    drawer.hidden = false;
    drawer.offsetHeight;
    drawer.classList.add('is-open');
    document.body.classList.add('np-cart-drawer-active');
    isOpen = true;
    hideLegacyPopup();

    if (options.refresh !== false) {
      refresh(false);
    }

    setTimeout(function() {
      var closeButton = drawer.querySelector(selectors.close);
      if (closeButton) closeButton.focus();
    }, 220);
  }

  function close() {
    if (!drawer || !isOpen) return;

    drawer.classList.remove('is-open');
    document.body.classList.remove('np-cart-drawer-active');
    unlockPageScroll();
    isOpen = false;

    setTimeout(function() {
      if (!isOpen) drawer.hidden = true;
    }, 240);

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  function lockPageScroll(scrollPosition) {
    lockedScrollPosition = scrollPosition || window.pageYOffset || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('np-cart-drawer-lock');
    document.body.style.setProperty('--np-cart-drawer-scroll-offset', '-' + lockedScrollPosition + 'px');
    document.body.classList.add('np-cart-drawer-lock');
  }

  function unlockPageScroll() {
    document.documentElement.classList.remove('np-cart-drawer-lock');
    document.body.classList.remove('np-cart-drawer-lock');
    document.body.style.removeProperty('--np-cart-drawer-scroll-offset');
    window.scrollTo(0, lockedScrollPosition);
  }

  function refresh(announce) {
    if (!drawer || isFetching) return;

    isFetching = true;
    clearError();

    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Unable to load cart.');
        return response.json();
      })
      .then(function(cart) {
        renderCart(cart);
        updateThemeCartCount(cart.item_count);
        if (announce) announceChange('Cart updated.');
      })
      .catch(function(error) {
        showError(error.message || 'Unable to refresh cart.');
      })
      .finally(function() {
        isFetching = false;
      });
  }

  function renderCart(cart) {
    cart = cart || {};

    if (removeOrphanedWelcome55(cart)) return;

    var items = Array.isArray(cart.items) ? cart.items : [];
    var itemCount = typeof cart.item_count === 'number' ? cart.item_count : 0;
    var hasItems = itemCount > 0;

    if (countNode) countNode.textContent = itemCount;
    if (subtotalNode) subtotalNode.textContent = formatMoney(cart.total_price || 0);
    if (checkoutButton) checkoutButton.disabled = !hasItems;

    renderDiscount(cart);
    renderShipping(cart.total_price || 0);

    setCartContentState(hasItems);
    if (itemList) itemList.innerHTML = '';

    if (!hasItems) return;

    items.forEach(function(item) {
      itemList.appendChild(renderItem(item));
    });
  }

  function setCartContentState(hasItems) {
    if (drawer) {
      drawer.classList.toggle('has-items', hasItems);
      drawer.classList.toggle('is-empty', !hasItems);
    }

    if (emptyState) {
      emptyState.hidden = hasItems;
      emptyState.setAttribute('aria-hidden', hasItems ? 'true' : 'false');
    }

    if (itemList) {
      itemList.hidden = !hasItems;
      itemList.setAttribute('aria-hidden', hasItems ? 'false' : 'true');
    }

    if (footerNode) {
      footerNode.hidden = !hasItems;
      footerNode.setAttribute('aria-hidden', hasItems ? 'false' : 'true');
    }
  }

  function renderShipping(totalPrice) {
    var freeShippingThreshold = 10000;
    var unlockedMessageThreshold = 10000;
    var remaining = Math.max(freeShippingThreshold - Number(totalPrice || 0), 0);
    var progress = Math.min(Math.max(Number(totalPrice || 0) / freeShippingThreshold * 100, 0), 100);

    if (shippingTextNode) {
      shippingTextNode.textContent = totalPrice >= unlockedMessageThreshold
        ? 'Congrats! You\'ve unlocked FREE SHIPPING!'
        : 'You are ' + formatMoney(remaining) + ' away from FREE SHIPPING';
    }

    if (shippingFillNode) {
      shippingFillNode.style.width = progress + '%';
    }
  }

  function renderDiscount(cart) {
    var savings = getCartSavings(cart);

    if (discountAmountNode) {
      discountAmountNode.textContent = savings > 0 ? '-' + formatMoney(savings) : formatMoney(0);
    }

    if (discountPillsNode) {
      discountPillsNode.innerHTML = '';
    }

    if (discountNode) {
      discountNode.hidden = savings <= 0;
    }
  }

  function getCartSavings(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var regularMerchandiseTotal = items.reduce(function(total, item) {
      var pricing = getLinePricing(item);
      var regularLinePrice = pricing.showOriginal ? pricing.originalPrice : pricing.finalPrice;
      return total + Math.max(Number(regularLinePrice || 0), Number(pricing.finalPrice || 0));
    }, 0);
    var actualCartTotal = Number(cart && cart.total_price || 0);

    return Math.max(regularMerchandiseTotal - actualCartTotal, 0);
  }

  function removeOrphanedWelcome55(cart) {
    var hasOfferLine = hasMenopauseOfferLine(cart);
    var removedOfferLine = lastCartHadMenopauseOfferLine === true && !hasOfferLine;
    var welcome55IsActive = getCartDiscountTitles(cart).some(function(title) {
      return String(title || '').toLowerCase() === 'welcome55';
    });

    lastCartHadMenopauseOfferLine = hasOfferLine;

    if (hasOfferLine || (!removedOfferLine && !welcome55IsActive)) return false;
    if (isOfferDiscountCleanup) return true;

    isOfferDiscountCleanup = true;

    var remainingCodes = getAppliedDiscountCodes(cart).filter(function(code) {
      return String(code || '').toLowerCase() !== 'welcome55';
    });

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: remainingCodes.join(',') })
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Unable to clear the expired welcome offer.');
        return response.json();
      })
      .then(function(updatedCart) {
        renderCart(updatedCart);
        updateThemeCartCount(updatedCart.item_count);
      })
      .catch(function(error) {
        showError(error.message || 'Unable to update the welcome offer.');
      })
      .finally(function() {
        isOfferDiscountCleanup = false;
      });

    return true;
  }

  function hasMenopauseOfferLine(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];

    return items.some(function(item) {
      var properties = item && item.properties;
      return !!(
        item &&
        item.selling_plan_allocation &&
        properties &&
        String(properties._menopause_offer || '').toLowerCase() === 'welcome55'
      );
    });
  }

  function getAppliedDiscountCodes(cart) {
    var codes = [];

    collectDiscountCodes(codes, cart && cart.discount_applications);
    collectDiscountCodes(codes, cart && cart.cart_level_discount_applications);

    if (cart && Array.isArray(cart.items)) {
      cart.items.forEach(function(item) {
        if (Array.isArray(item.line_level_discount_allocations)) {
          item.line_level_discount_allocations.forEach(function(allocation) {
            collectDiscountCodes(codes, [allocation && (allocation.discount_application || allocation)]);
          });
        }

        if (Array.isArray(item.discounts)) {
          item.discounts.forEach(function(discount) {
            if (discount && discount.code) addUniqueTitle(codes, discount.code);
          });
        }
      });
    }

    return codes;
  }

  function collectDiscountCodes(codes, applications) {
    if (!Array.isArray(applications)) return;

    applications.forEach(function(application) {
      if (!application) return;

      var type = String(application.type || '').toLowerCase();
      var code = application.code || (type === 'discount_code' ? application.title : '');

      if (code) addUniqueTitle(codes, code);
    });
  }

  function renderItem(item) {
    var li = document.createElement('li');
    var key = item.key || '';
    var imageUrl = getSizedImageUrl(getImageUrl(item));
    var productUrl = item.url || '/cart';
    var title = item.product_title || item.title || 'Product';
    var variantTitle = getVariantLabel(item);
    var sellingPlan = item.selling_plan_allocation &&
      item.selling_plan_allocation.selling_plan &&
      item.selling_plan_allocation.selling_plan.name
      ? item.selling_plan_allocation.selling_plan.name
      : '';
    var pricing = getLinePricing(item);

    li.className = 'np-cart-drawer__item';
    li.setAttribute('data-line-key', key);

    li.innerHTML =
      '<a class="np-cart-drawer__image-link" href="' + escapeAttribute(productUrl) + '">' +
        (imageUrl
          ? '<img class="np-cart-drawer__image" src="' + escapeAttribute(imageUrl) + '" alt="' + escapeAttribute(title) + '" loading="lazy">'
          : '<span class="np-cart-drawer__image-placeholder">No image</span>') +
      '</a>' +
      '<div class="np-cart-drawer__item-details">' +
        '<a class="np-cart-drawer__item-title" href="' + escapeAttribute(productUrl) + '">' + escapeHtml(title) + '</a>' +
        '<div class="np-cart-drawer__meta">' +
          (variantTitle ? '<div>' + escapeHtml(variantTitle) + '</div>' : '') +
          (sellingPlan ? '<div class="np-cart-drawer__subscription"><span class="np-cart-drawer__subscription-label">Subscription:</span> <span class="np-cart-drawer__subscription-text">' + escapeHtml(sellingPlan) + '</span></div>' : '') +
        '</div>' +
        '<div class="np-cart-drawer__item-actions">' +
          '<div class="np-cart-drawer__qty" aria-label="Quantity for ' + escapeAttribute(title) + '">' +
            '<button class="np-cart-drawer__qty-button" type="button" data-np-cart-drawer-qty="decrease" data-line-key="' + escapeAttribute(key) + '" aria-label="Decrease quantity">' +
              '<span class="np-cart-drawer__qty-symbol">&#8722;</span>' +
              renderLoadingIcon() +
            '</button>' +
            '<input class="np-cart-drawer__qty-input" type="number" min="0" value="' + Number(item.quantity || 0) + '" data-np-cart-drawer-qty-input data-line-key="' + escapeAttribute(key) + '" aria-label="Quantity">' +
            '<button class="np-cart-drawer__qty-button" type="button" data-np-cart-drawer-qty="increase" data-line-key="' + escapeAttribute(key) + '" aria-label="Increase quantity">' +
              '<span class="np-cart-drawer__qty-symbol">+</span>' +
              renderLoadingIcon() +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="np-cart-drawer__item-side">' +
        '<button class="np-cart-drawer__remove" type="button" data-np-cart-drawer-remove data-line-key="' + escapeAttribute(key) + '" aria-label="Remove ' + escapeAttribute(title) + '">' +
          '<svg class="np-cart-drawer__remove-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
            '<path d="M7 7h10l-.6 12H7.6L7 7Z"></path>' +
            '<path d="M9 4.75h6M5.5 7h13"></path>' +
          '</svg>' +
        '</button>' +
        '<div class="np-cart-drawer__price-block">' +
          '<div class="np-cart-drawer__line-price">' +
            (pricing.showOriginal ? '<span class="np-cart-drawer__line-price-original">' + formatMoney(pricing.originalPrice) + '</span>' : '') +
            '<span class="np-cart-drawer__line-price-final">' + formatMoney(pricing.finalPrice) + '</span>' +
          '</div>' +
        '</div>' +
      '</div>';

    return li;
  }

  function renderLoadingIcon() {
    return '<svg class="np-cart-drawer__qty-loading-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M17.7 7.1A7 7 0 1 0 19 12"></path>' +
      '<path d="M18 3v5h-5"></path>' +
    '</svg>';
  }

  function renderDiscountPill(title, amount, includeAmount) {
    var label = title || 'Discount';
    var amountText = includeAmount && amount > 0 ? ' (-' + formatMoney(amount) + ')' : '';

    return '<span class="np-cart-drawer__discount-pill">' +
      '<svg class="np-cart-drawer__discount-tag-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z"></path>' +
        '<circle cx="8" cy="8" r="1.4"></circle>' +
      '</svg>' +
      '<span>' + escapeHtml(label + amountText) + '</span>' +
    '</span>';
  }

  function handleQuantityButton(button) {
    var key = button.getAttribute('data-line-key');
    var item = button.closest('.np-cart-drawer__item');
    var input = item && item.querySelector('[data-np-cart-drawer-qty-input]');
    var current = input ? parseInt(input.value, 10) : 0;
    var next = button.getAttribute('data-np-cart-drawer-qty') === 'increase' ? current + 1 : current - 1;

    if (isNaN(next) || next < 0) next = 0;
    if (input) input.value = next;
    queueQuantityChange(key, next, button);
  }

  function queueQuantityChange(key, quantity, button) {
    if (!key) return;
    clearTimeout(quantityTimers[key]);
    setQuantityButtonLoading(key, button);
    quantityTimers[key] = setTimeout(function() {
      changeQuantity(key, quantity, button);
    }, 250);
  }

  function changeQuantity(key, quantity, button) {
    if (!key) return;

    clearError();

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: Number(quantity)
      })
    })
      .then(function(response) {
        if (!response.ok) {
          return response.json().catch(function() {
            return {};
          }).then(function(error) {
            throw new Error(error.description || error.message || 'Unable to update cart.');
          });
        }
        return response.json();
      })
      .then(function(cart) {
        renderCart(cart);
        updateThemeCartCount(cart.item_count);
        announceChange('Cart updated.');
        document.dispatchEvent(new CustomEvent('np-cart-drawer:updated', {
          bubbles: true,
          detail: { cart: cart }
        }));
      })
      .catch(function(error) {
        showError(error.message || 'Unable to update cart.');
        refresh(false);
      })
      .finally(function() {
        clearQuantityButtonLoading(key, button);
      });
  }

  function setQuantityButtonLoading(key, button) {
    clearQuantityButtonLoading(key);

    if (!button) return;

    quantityLoadingButtons[key] = button;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
  }

  function clearQuantityButtonLoading(key, button) {
    var loadingButton = button || quantityLoadingButtons[key];

    if (loadingButton) {
      loadingButton.classList.remove('is-loading');
      loadingButton.removeAttribute('aria-busy');
    }

    if (quantityLoadingButtons[key] === loadingButton || !button) {
      delete quantityLoadingButtons[key];
    }
  }

  function watchAjaxAddToCart() {
    patchFetch();
    patchXHR();
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.__npCartDrawerPatched) return;

    var originalFetch = window.fetch;

    function patchedFetch(input, init) {
      var url = getRequestUrl(input);
      var responsePromise = originalFetch.apply(this, arguments);

      if (isCartAddUrl(url)) {
        responsePromise.then(function(response) {
          if (response && response.ok) scheduleOpenFromAdd();
        }).catch(function() {});
      }

      return responsePromise;
    }

    patchedFetch.__npCartDrawerPatched = true;
    window.fetch = patchedFetch;
  }

  function patchXHR() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.__npCartDrawerPatched) return;

    var XHR = window.XMLHttpRequest;
    var originalOpen = XHR.prototype.open;
    var originalSend = XHR.prototype.send;

    XHR.prototype.open = function(method, url) {
      this.__npCartDrawerUrl = url;
      return originalOpen.apply(this, arguments);
    };

    XHR.prototype.send = function() {
      if (isCartAddUrl(this.__npCartDrawerUrl)) {
        this.addEventListener('load', function() {
          if (this.status >= 200 && this.status < 300) scheduleOpenFromAdd();
        });
      }

      return originalSend.apply(this, arguments);
    };

    window.XMLHttpRequest.__npCartDrawerPatched = true;
  }

  function scheduleOpenFromAdd() {
    var scrollPosition = window.pageYOffset || document.documentElement.scrollTop || 0;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function() {
      open({ refresh: true, scrollPosition: scrollPosition });
    }, 180);
  }

  function hideLegacyPopup() {
    var popup = document.querySelector(selectors.cartPopupWrapper);
    if (!popup) return;
    popup.classList.add('cart-popup-wrapper--hidden');
    popup.setAttribute('aria-hidden', 'true');
  }

  function observeLegacyPopup() {
    var popup = document.querySelector(selectors.cartPopupWrapper);
    if (!popup || !window.MutationObserver) return;

    var observer = new MutationObserver(function() {
      if (!isOpen || popup.classList.contains('cart-popup-wrapper--hidden')) return;

      hideLegacyPopup();

      var closeButton = drawer.querySelector(selectors.close);
      if (closeButton) closeButton.focus();
    });

    observer.observe(popup, {
      attributes: true,
      attributeFilter: ['class', 'aria-hidden']
    });
  }

  function getRequestUrl(input) {
    if (!input) return '';
    if (typeof input === 'string') return input;
    if (input.url) return input.url;
    return '';
  }

  function isCartAddUrl(url) {
    if (!url) return false;
    return String(url).indexOf('/cart/add') !== -1;
  }

  function isCartPageLink(link) {
    try {
      var url = new URL(link.href, window.location.origin);
      return url.origin === window.location.origin && url.pathname.replace(/\/$/, '') === '/cart';
    } catch (error) {
      return false;
    }
  }

  function getCartDiscountTitles(cart) {
    var titles = [];

    if (!cart || Number(cart.total_discount || 0) <= 0) return titles;

    addDiscountApplicationTitles(titles, cart.discount_applications);
    addDiscountApplicationTitles(titles, cart.cart_level_discount_applications);

    if (Array.isArray(cart.items)) {
      cart.items.forEach(function(item) {
        getLineDiscounts(item).forEach(function(discount) {
          addUniqueTitle(titles, discount.title);
        });
      });
    }

    if (titles.length > 1) {
      titles = titles.filter(function(title) {
        return title !== 'Discount';
      });
    }

    return titles.length ? titles : ['Discount'];
  }

  function addDiscountApplicationTitles(titles, applications) {
    if (!Array.isArray(applications)) return;

    applications.forEach(function(application) {
      if (!application) return;
      addUniqueTitle(titles, application.title || application.code || application.description);
    });
  }

  function getLineDiscounts(item) {
    var discounts = {};
    var hasLineLevelDiscounts = false;

    if (!item) return [];

    if (Array.isArray(item.line_level_discount_allocations)) {
      item.line_level_discount_allocations.forEach(function(allocation) {
        if (!allocation || Number(allocation.amount || 0) <= 0) return;

        var application = allocation.discount_application || {};
        var title = application.title || application.code || allocation.title || allocation.discount_application_title || 'Discount';

        hasLineLevelDiscounts = true;
        addLineDiscount(discounts, title, allocation.amount);
      });
    }

    if (!hasLineLevelDiscounts && Array.isArray(item.discounts)) {
      item.discounts.forEach(function(discount) {
        if (!discount || Number(discount.amount || 0) <= 0) return;
        addLineDiscount(discounts, discount.title || discount.code || 'Discount', discount.amount);
      });
    }

    return Object.keys(discounts).map(function(title) {
      return {
        title: title,
        amount: discounts[title]
      };
    });
  }

  function addLineDiscount(discounts, title, amount) {
    var safeTitle = title || 'Discount';
    discounts[safeTitle] = (discounts[safeTitle] || 0) + Number(amount || 0);
  }

  function addUniqueTitle(titles, title) {
    var safeTitle = title || 'Discount';
    if (titles.indexOf(safeTitle) === -1) titles.push(safeTitle);
  }

  function getImageUrl(item) {
    if (item.image) return item.image;
    if (item.featured_image && item.featured_image.url) return item.featured_image.url;
    return '';
  }

  function getSizedImageUrl(url) {
    if (!url) return '';

    var parts = String(url).split('?');
    var base = parts[0];
    var query = parts.length > 1 ? '?' + parts.slice(1).join('?') : '';

    base = base.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|\d+x\d*|\d*x\d+|x\d+)(\.[a-zA-Z0-9]+)$/i, '$2');

    if (!/\.[a-zA-Z0-9]+$/.test(base)) return String(url);

    return base.replace(/(\.[a-zA-Z0-9]+)$/i, '_300x$1') + query;
  }

  function getVariantLabel(item) {
    if (!item.variant_title || item.variant_title === 'Default Title') return '';
    if (String(item.variant_title).indexOf('Size:') === 0) return item.variant_title;
    return 'Size: ' + item.variant_title;
  }

  function getLinePrice(item) {
    if (typeof item.final_line_price === 'number') return item.final_line_price;
    if (typeof item.line_price === 'number') return item.line_price;
    if (typeof item.price === 'number' && typeof item.quantity === 'number') {
      return item.price * item.quantity;
    }
    return 0;
  }

  function getLinePricing(item) {
    var finalLinePrice = getLinePrice(item);
    var originalLinePrice = getOriginalLinePrice(item);
    var subscriptionUnitComparePrice = getSubscriptionUnitComparePrice(item);
    var compareLinePrice = 0;

    if (subscriptionUnitComparePrice > 0) {
      compareLinePrice = subscriptionUnitComparePrice * getItemQuantity(item);
    } else if (originalLinePrice > finalLinePrice) {
      compareLinePrice = originalLinePrice;
    }

    return {
      finalPrice: finalLinePrice,
      originalPrice: compareLinePrice,
      showOriginal: compareLinePrice > finalLinePrice
    };
  }

  function getOriginalLinePrice(item) {
    if (typeof item.original_line_price === 'number') return item.original_line_price;
    if (typeof item.line_price === 'number') return item.line_price;
    if (typeof item.original_price === 'number' && typeof item.quantity === 'number') {
      return item.original_price * item.quantity;
    }
    return getLinePrice(item);
  }

  function getSubscriptionUnitComparePrice(item) {
    if (!item || !item.selling_plan_allocation) return 0;

    var activeUnitPrice = getFinalUnitPrice(item);
    var candidates = [];
    var allocation = item.selling_plan_allocation;

    addPriceCandidate(candidates, allocation.compare_at_price);

    if (Array.isArray(allocation.price_adjustments)) {
      allocation.price_adjustments.forEach(function(adjustment) {
        if (!adjustment) return;
        addPriceCandidate(candidates, adjustment.compare_at_price);
      });
    }

    addPriceCandidate(candidates, item.original_price);
    addPriceCandidate(candidates, getOriginalLinePrice(item) / getItemQuantity(item));
    addPriceCandidate(candidates, item.variant && item.variant.compare_at_price);
    addPriceCandidate(candidates, item.variant && item.variant.price);
    addProductVariantPriceCandidates(candidates, item);

    for (var i = 0; i < candidates.length; i += 1) {
      if (candidates[i] > activeUnitPrice) return candidates[i];
    }

    return 0;
  }

  function addProductVariantPriceCandidates(candidates, item) {
    if (!item || !item.product || !Array.isArray(item.product.variants)) return;

    for (var i = 0; i < item.product.variants.length; i += 1) {
      var variant = item.product.variants[i];
      if (!variant || Number(variant.id) !== Number(item.variant_id)) continue;

      addPriceCandidate(candidates, variant.compare_at_price);
      addPriceCandidate(candidates, variant.price);
      return;
    }
  }

  function addPriceCandidate(candidates, value) {
    var price = Number(value);
    if (!isNaN(price) && price > 0) candidates.push(price);
  }

  function getFinalUnitPrice(item) {
    if (typeof item.final_price === 'number') return item.final_price;
    if (typeof item.price === 'number') return item.price;
    return getLinePrice(item) / getItemQuantity(item);
  }

  function getItemQuantity(item) {
    var quantity = Number(item && item.quantity);
    return quantity > 0 ? quantity : 1;
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.moneyFormat || '${{amount}}');
    }

    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function updateThemeCartCount(count) {
    var countValue = Number(count || 0);
    var countNodes = document.querySelectorAll(selectors.cartCount);
    var bubbles = document.querySelectorAll(selectors.cartCountBubble);

    Array.prototype.forEach.call(countNodes, function(node) {
      node.textContent = countValue;
    });

    Array.prototype.forEach.call(bubbles, function(node) {
      if (countValue > 0) {
        node.classList.remove('hide');
      } else {
        node.classList.add('hide');
      }
    });
  }

  function showError(message) {
    if (!errorNode) return;
    errorNode.textContent = message;
    errorNode.hidden = false;
  }

  function clearError() {
    if (!errorNode) return;
    errorNode.textContent = '';
    errorNode.hidden = true;
  }

  function announceChange(message) {
    if (!liveRegion) return;
    liveRegion.textContent = message;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/`/g, '&#096;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
